export const ATTRIBUTE_LIST_DEFAULT_SOURCE = 'tm-default-layers-source';
